import React from 'react';
import { Gift, Lock } from 'lucide-react';
import { useLang, tx } from '../i18n/LanguageContext';

export const FreeToggle = ({ value, onChange, testId, disabled }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <button
      type="button"
      data-testid={testId}
      aria-pressed={!!value}
      disabled={disabled}
      onClick={() => onChange(!value)}
      title={L('اضغط للتبديل بين مجاني ومدفوع', 'Click to toggle free / paid')}
      className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-xs font-extrabold border transition-[background-color,border-color,color,transform] duration-200 active:scale-95 disabled:opacity-60 ${value ? 'bg-emerald-500 border-emerald-500 text-white shadow-sm shadow-emerald-500/30' : 'bg-amber-50 border-amber-300 text-amber-700 hover:bg-amber-100'}`}
    >
      {value ? <Gift className="w-3.5 h-3.5" /> : <Lock className="w-3.5 h-3.5" />}
      {value ? L('مجاني', 'Free') : L('مدفوع', 'Paid')}
    </button>
  );
};
